import { PatientModal } from '@modal'
import PatientNavbar from '@pages/Patient/Navbar'
import { Suspense, useEffect, useState } from 'react'
import { FiMenu, FiX } from 'react-icons/fi'
import { Outlet, useLocation } from 'react-router-dom'
import PatientSidebar from '../Sidebar/PatientSidebar'

const PatientLayout = () => {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false)
  const { pathname } = useLocation()

  useEffect(() => {
    setMobileSidebarOpen(false)
  }, [pathname])

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-[#F7F9FC]">
      <aside className="hidden h-full md:block">
        <PatientSidebar />
      </aside>

      <div className="relative my-2 mr-2 flex min-w-0 flex-1 flex-col overflow-hidden rounded-[20px] border border-[#F0F0F0] bg-white p-4 pb-4 md:my-3.5 md:mr-3.5 md:p-6">
        <div className="mb-4 flex shrink-0 items-start gap-3 md:mb-5">
          <button
            aria-label="Open patient menu"
            className="mt-0.5 rounded-lg border border-[#E2E2E2] bg-white p-2 text-[#4B4B4B] md:hidden"
            onClick={() => setMobileSidebarOpen(true)}
            type="button"
          >
            <FiMenu size={20} />
          </button>
          <PatientNavbar />
        </div>

        <div className="flex min-h-0 flex-1 flex-col overflow-auto">
          {/* null fallback: InstantLoading blanked Chart tabs under the sticky "Chart" navbar */}
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </div>
      </div>

      {mobileSidebarOpen ? (
        <div className="fixed inset-0 z-50 md:hidden">
          <button
            aria-label="Close sidebar overlay"
            className="absolute inset-0 bg-black/35"
            onClick={() => setMobileSidebarOpen(false)}
            type="button"
          />
          <div className="relative h-full w-[min(86vw,280px)] max-w-[280px] bg-white">
            <button
              aria-label="Close patient menu"
              className="absolute right-3 top-3 z-10 rounded-md border border-[#E2E2E2] bg-white p-1.5 text-[#4B4B4B]"
              onClick={() => setMobileSidebarOpen(false)}
              type="button"
            >
              <FiX size={18} />
            </button>
            <PatientSidebar />
          </div>
        </div>
      ) : null}
      <PatientModal />
    </div>
  )
}

export default PatientLayout
